import React from 'react';

const InputField = ({
  prefix,
  placeholder,
  value,
  onChange,
  type = 'text',
  disabled = false,
  error = false,
  className = '',
  ...props
}) => {
  const handleChange = (e) => {
    if (type === 'number') {
      const numValue = e.target.value;
      onChange(numValue);
    } else {
      onChange(e.target.value);
    }
  };

  return (
    <div className="relative w-full">
      {prefix && (
        <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-700 font-medium">
          {prefix}
        </span>
      )}
      <input
        type={type === 'number' ? 'text' : type}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        className={`
          w-full px-4 py-2.5 rounded-lg border-2 transition-all duration-200 text-sm
          ${prefix ? 'pl-8' : 'pl-4'}
          ${error ? 'border-red-500' : 'border-gray-300'}
          ${!disabled && !error ? 'focus:border-purple-500 focus:outline-none' : ''}
          ${disabled ? 'bg-gray-100 cursor-not-allowed text-gray-500' : 'bg-white text-gray-900'}
          placeholder:text-gray-400
          ${className}
        `}
        {...props}
      />
    </div>
  );
};

export default InputField;
